import { type EnvironmentProviders, NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import { TellentFeatureDiscoveryEffects } from './feature-discovery-effects.service';
import {
  TellentFeatureDiscoveryNamespace,
  TellentFeatureDiscoveryReducer,
} from './feature-discovery.store';

@NgModule({
  imports: [
    StoreModule.forFeature(TellentFeatureDiscoveryNamespace, TellentFeatureDiscoveryReducer),
    EffectsModule.forFeature([TellentFeatureDiscoveryEffects]),
  ],
})
export class TellentFeatureDiscoveryDataModule {}

const provideFeatureDiscoveryState = provideState(
  TellentFeatureDiscoveryNamespace,
  TellentFeatureDiscoveryReducer,
);
const provideFeatureDiscoveryEffects = provideEffects([TellentFeatureDiscoveryEffects]);

export const featureDiscoveryStoreProviders: EnvironmentProviders[] = [
  provideFeatureDiscoveryEffects,
  provideFeatureDiscoveryState,
];
